import React from "react";
import CardLeft from "@nvs/gatsby-theme-leap-core/src/components/domains/confirmation/components/services/copay/card-left";
import Card from "@nvs/gatsby-theme-leap-core/src/components/domains/confirmation/components/services/card/components/card";
import { CardData } from "@nvs/gatsby-theme-leap-core/src/components/domains/confirmation/components/services/card";
import { Service } from "@nvs/gatsby-theme-leap-core/src/components/hoc/context/product/configuration-model";
import EcdCard from "@nvs/gatsby-theme-leap-core/src/components/domains/confirmation/components/services/card/components/ecd-card";
import usePages from "@nvs/gatsby-theme-leap-core/src/hooks/usePages";
import Femara from "../../../../../../../../components/femara";

const CopayCard: React.FC<{
  service: Service;
  data: CardData;
  printMode?: boolean;
}> = ({ service, data, printMode = false }) => {

  const { ecd } = usePages();

	return (
		<>
			{ecd ? (
				<EcdCard data={data} printMode={printMode} />
			) : (
				<Card data={data} printMode={printMode}>
					<CardLeft service={service} data={data} printMode={printMode} />
				</Card>
			)}
      <Femara />
		</>
	);

};

export default CopayCard;
